// Check if the app is running in standalone mode (installed as PWA)
export const isInStandaloneMode = (): boolean => {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    (window.navigator as any).standalone === true ||
    document.referrer.includes('android-app://')
  );
};

// Check if the device is a mobile device
export const isMobileDevice = (): boolean => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

// Check if the browser supports PWA installation
export const isPWAInstallable = (): boolean => {
  return 'BeforeInstallPromptEvent' in window || 
         (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches);
};

// Check if we should show the install button
export const shouldShowInstallButton = (): boolean => {
  return isMobileDevice() && !isInStandaloneMode() && isPWAInstallable();
};
